import { createRouter, createWebHistory } from 'vue-router';
import authRoutes from '@/modules/auth/routes';
import scanRoutes from '@/modules/scan/routes';

const routes = [
  ...authRoutes,
  ...scanRoutes
];

const router = createRouter({
  history: createWebHistory(), // Use HTML5 history mode
  routes,
});


router.beforeEach((to, from, next) => {
  // Update the page title if the route has a meta title
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // Check if the route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isAuthenticated = localStorage.getItem('accessToken'); // Example check for authentication

    if (!isAuthenticated) {
      // If not authenticated, redirect to the login page
      next({
        path: '/',
        query: { redirect: to.fullPath }, // Store the full path to redirect after login
      });
    } else {
      // If authenticated, allow access to the route
      next();
    }
  } else {
    // If no authentication is required, allow access
    next();
  }
});



export default router;